// src/profiles/BusinessProfileNew.js
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useLocation } from 'react-router-dom'
import * as jwtDecode from 'jwt-decode'
import { API_BASE_URL } from '../config'
import Loader from '../components/Loader'
import './BusinessProfileNew.css'
import Button from './ui/Button'
import Card from './ui/Card'
import Badge from './ui/Badge'
import Avatar from './ui/Avatar'
import Dialog from './ui/Dialog'
import ScrollArea from './ui/ScrollArea'
import styles from './BusinessProfileNew.module.css'

import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import RenovationIcon from '../images/home-landing-page/renovation-icon.png';
import Checkmark from '../images/home-landing-page/blue-checkmark.png';

import { CheckCircle, ListChecks, Tool, GraduationCap, Award } from 'lucide-react'
import { Info, PhoneCall, Globe, Mail, Star, BarChart2, MapPin } from 'lucide-react'
import {
  Smartphone,      // for SMS
  MessageCircle,   // for Chat message
  Quote,           // for Quote
  User             // for User profile
} from 'lucide-react'

import {

  Bookmark,
  Share2,
  Briefcase,
  Users,
  MessageSquare
} from 'lucide-react'




const BusinessProfileNewV2 = ({ isOpen, onClose, businessId: businessIdFromProp }) => {
  const [businessProfile, setBusinessProfile] = useState(null)
  const [services, setServices] = useState([])
  const [certifications, setCertifications] = useState([])
  const [qualifications, setQualifications] = useState([])
  const [portfolio, setPortfolio] = useState([])
  const [reviews, setReviews] = useState([])
  const [jobsCompleted, setJobsCompleted] = useState(0)
  const [jobsQuote, setJobsQuote] = useState(0)
  const [conversationsCount, setConversationsCount] = useState(0)
  const [loading, setLoading] = useState(true)
  const [showAllReviews, setShowAllReviews] = useState(false)
  const [selectedPortfolioItem, setSelectedPortfolioItem] = useState(null)
  const [isSaved, setIsSaved] = useState(false);
  const [isRendered, setIsRendered] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsRendered(true);
    } else {
      const timer = setTimeout(() => setIsRendered(false), 300); // Match animation duration
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const businessIdFromQuery = queryParams.get('businessId')
  const decodedBusinessIdFromQuery = businessIdFromProp ? atob(businessIdFromProp) : (businessIdFromQuery ? atob(businessIdFromQuery) : null)
  const mapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY



  useEffect(() => {

    //console.log(process.env.REACT_APP_GOOGLE_MAPS_API_KEY)


        const myuserType = sessionStorage.getItem('userType');
        const loggedInBusinessId = sessionStorage.getItem('loggedInBusinessId');
        const loggedInHomeUserId = sessionStorage.getItem('loggedInHomeUserId');

        console.log('stored userType', myuserType);
        console.log('stored loggedInBusinessId', loggedInBusinessId);
        console.log('stored loggedInHomeUserId', loggedInHomeUserId);



    const fetchBusinessProfile = async () => {
      setLoading(true)
      try {
        // determine businessId
        const token = localStorage.getItem('token')
        let decoded = null
        if (token) {
          try { decoded = jwtDecode(token) } catch {}
        }
        let businessId
        if (decoded && decoded.BusinessId && !decodedBusinessIdFromQuery) {
          businessId = decoded.BusinessId
        } else {
          businessId = decodedBusinessIdFromQuery
        }

        const userId = decoded?.nameid || null

        console.log(`businessId = ${businessId}`);
        console.log(`userId = ${userId}`);

        const resp = await axios.get(
          `${API_BASE_URL}/api/BusinessProfile/getBusinessProfile?businessId=${businessId}`
        )
        const data = resp.data

        setBusinessProfile(data.businesses)
        setServices(data.services || [])
        setCertifications(data.certifications || [])
        setQualifications(data.qualificationDtos || [])
        setPortfolio(data.workPortfolio?.model || [])
        setReviews(data.reviewOfCustomer || [])
        setJobsCompleted(data.jobsCompleted ?? 0)
        setJobsQuote(data.jobsQuote ?? 0)
        setConversationsCount(data.conversation ?? 0)
      } catch (err) {
        console.error('Failed to fetch business profile:', err)
      } finally {
        setLoading(false)
      }
    }


  const checkIfSaved = async () => {
    // show spinner if you like
    try {
      const userType   = localStorage.getItem('userType');
      const homeUserId = parseInt(localStorage.getItem('homeUserId'), 10) || 0;
      const bizUserId  = parseInt(localStorage.getItem('businessId'), 10) || 0;
      const savedBizId = parseInt(decodedBusinessIdFromQuery, 10);

      if (!userType || !savedBizId) return;

      // build query params
      const params = new URLSearchParams({
        savedBusinessId: savedBizId,
        userType
      });
      if (userType === 'Home') {
        params.append('homeUserId', homeUserId);
      } else {
        params.append('businessId', bizUserId);
      }

      const { data } = await axios.get(
        `${API_BASE_URL}/api/BusinessProfile/isBusinessFavourite?${params.toString()}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );

      // data.isFavourite should be a bool
      if (typeof data.isFavourite === 'boolean') {
        setIsSaved(data.isFavourite);
      }
    } catch (err) {
      console.error('Error checking favourite status', err);
    }
  }

    // run the functions here
    fetchBusinessProfile();
    checkIfSaved();


  }, [businessIdFromQuery, decodedBusinessIdFromQuery])

  const renderStars = (rating) =>
    [...Array(5)].map((_, i) => (
      <span key={i} className={`star ${i < Math.floor(rating) ? 'filled' : 'empty'}`}>
        ★
      </span>
    ))

  const address = businessProfile
    ? `${businessProfile.streetNumber} ${businessProfile.streetName}, ${businessProfile.suburb}, ${businessProfile.myState} ${businessProfile.postCode}`
    : ''


    const mapsparams = new URLSearchParams({
      key: mapsApiKey,
      q: address
    }).toString();

    const mapsembedUrl = `https://www.google.com/maps/embed/v1/place?${mapsparams}`;

  const getDirections = () => {
    const url = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`
    window.open(url, '_blank')
  }

  const openGoogleMaps = () => {
    const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`
    window.open(url, '_blank')
  }

  if (!isRendered) return null;

  if (loading) {
    return (
      <div className={styles.profileModalOverlay}>
        <div className={styles.profileModal}>
          <div className={styles.profileModalContent}>Loading...</div>
        </div>
      </div>
    );
  }

  if (!businessProfile) {
    return (
        <div className={styles.profileModalOverlay}>
            <div className={styles.profileModal}>
                <div className={styles.profileModalContent}>
                    No business profile found.
                </div>
            </div>
        </div>
    );
  }

  // normalize website URL
  const rawWebsite = businessProfile.website || ''
  const websiteHref = rawWebsite.match(/^https?:\/\//)
    ? rawWebsite
    : `https://${rawWebsite}`


    const handleSaveFavourite = async () => {
      // 1. Read your stored values
      const userType    = localStorage.getItem('userType');
      const homeUserId  = parseInt(localStorage.getItem('loggedInHomeUserId'), 10)  || 0;
      const businessId  = parseInt(localStorage.getItem('loggedInBusinessId'), 10)  || 0;
      const savedBizId  = parseInt(decodedBusinessIdFromQuery,           10); // the profile you’re viewing
      
      console.log('stored userType', userType);
      console.log('stored loggedInBusinessId', businessId);
      console.log('stored loggedInHomeUserId', homeUserId);

      // 2. Build your payload
      const payload = {
        savedBusinessId: savedBizId,
        homeUserId:      userType === 'Home'     ? homeUserId   : 0,
        businessId:      userType === 'Business' ? businessId   : 0,
        userType,       // “Home” or “Business”
        commend: ''     // as per spec
      };

      console.log('payload:', payload);
      console.log('url:', `${API_BASE_URL}/api/BusinessProfile/toggleBusinessFavourite`);


  try {
        const { data } = await axios.post(
          `${API_BASE_URL}/api/BusinessProfile/toggleBusinessFavourite`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )

        console.log('data.status', data.status);

        // this is the key: pull isFavourite from data, not resp.isFavourite
        if ((data.status == 'saved') || (data.status == 'removed')) {

          var mySavedValue = true;

          if (data.status == 'saved') {
              mySavedValue = true;
          } else {
            mySavedValue = false;
          }

          setIsSaved(mySavedValue)
          toast.success(
            mySavedValue
              ? 'Added to your favourites'
              : 'Removed from your favourites'
          )
        } else {
          console.warn('Unexpected toggle response:', data.status)
          toast.error('Unexpected response from server.')
        }

      } catch (err) {
        console.error(err)
        toast.error('❌ Could not update favourite status.')
      }

    };



  return (
    <div className={styles.profileModalOverlay} onClick={onClose}>
      <div 
        className={`${styles.profileModal} ${!isOpen ? styles.hidden : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
      />

      {/* Header */}
      <div className={styles['header-section']}>
        <div className={styles['container']}>
          <div className={styles['header-content']}>
            <Avatar
              src={businessProfile.profilePic}
              alt={businessProfile.businessName}
              fallback={businessProfile.businessName?.charAt(0)}
              size="large"
            />

            <div className={styles['header-info']}>
              <div className={styles['header-main']}>
                <div className={styles['business-details']}>
                  <h1 className="business-name-p">{businessProfile.businessName}</h1>
                  <div className="location">
                    <span className="icon">
                          <MapPin
                            size={20}                   
                            strokeWidth={2}             
                            className="mywhitecolor"    
                          />

                    </span>
                    <span>{address}</span>
                  </div>
                  <div className="rating">
                    <div className="stars">
                      {renderStars(businessProfile.overallRating)}
                      <span className="rating-number">{businessProfile.overallRating}</span>
                      <span className="review-count">({reviews.length} reviews)</span>
                    </div>
                  </div>
                </div>

                <div className="header-actions">
                  <Button
                    className="call-button-p"
                    onClick={() => (window.location.href = `tel:${businessProfile.phone}`)}
                  >
                    
                          <PhoneCall
                            size={24}                   
                            strokeWidth={2}             
                            className="myblackcolor"    
                          />
                    
                     &nbsp; &nbsp; Call Now: {businessProfile.phone}
                  </Button>

                  <Button variant="outline" className="save-button" onClick={handleSaveFavourite}>

                    <Bookmark
                      size={20}
                      strokeWidth={2}
                      fill={isSaved ? 'orange' : 'none'}
                      stroke={isSaved ? 'none' : 'currentColor'}
                      color={isSaved ? 'orange' : undefined}
                    />


                      &nbsp;&nbsp;
                      {isSaved ? 'Saved' : 'Save'}

                  </Button>

                  <Button variant="outline" className="share-button">
                    
                  
                    <Share2
                      size={20}                   // px size
                      strokeWidth={2}             // line thickness
                      className="mywhitecolor"    // use your existing CSS hook
                    />

                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container main-content">
        <div className="content-grid">
          <div className="main-column">
            {/* About */}
            <Card>
              <div className="card-header">
                <h2 className="card-title">
                  
                          <Info
                            size={32}                   
                            strokeWidth={2}             
                            className="service-icon"    
                          />
                  
                   About Our Services</h2>
              </div>
              <div className="card-content">
                <p className="description">
                  {businessProfile.description || 'No description available.'}
                </p>
              </div>
            </Card>

            {/* Services */}
            <Card>
              <div className="card-header">
                <h2 className="card-title">
                  
                  <ListChecks
                    size={32}                   
                    strokeWidth={2}             
                    className="service-icon"    
                  />
                  
                   Services Offered</h2>
              </div>
              <div className="card-content">
                <div className="services-grid">
                  {services.length > 0 ? (
                    services.map((svc) => (
                      <div key={svc.serviceId} className="service-item">
                        <span className="service-icon">

                          <ListChecks
                            size={24}                   
                            strokeWidth={2}             
                            className="service-icon"    
                          />


                        </span>
                        <span className="service-name">{svc.name}</span>
                      </div>
                    ))
                  ) : (
                    <p>No services offered.</p>
                  )}
                </div>
              </div>
            </Card>

            {/* Certifications */}
            <Card>
              <div className="card-header">
                <h2 className="card-title">
                  
                  <CheckCircle
                    size={32}                   // px size
                    strokeWidth={2}             // line thickness
                    className="service-icon"    // use your existing CSS hook
                  />
                  
                   Certified for: </h2>
              </div>
              <div className="card-content">
                <div className="services-grid">
                  {certifications.length > 0 ? (
                    certifications.map((cert) => (
                      <div key={cert.certificationId} className="certification-item">

                      <CheckCircle
                        size={24}                   // px size
                        strokeWidth={2}             // line thickness
                        className="service-icon"    // use your existing CSS hook
                      />

                        <span >{cert.name}</span>
                      </div>
                    ))
                  ) : (
                    <p>No certifications</p>
                  )}
                </div>
              </div>
            </Card>


            {/* Portfolio */}
            <Card>
              <div className="card-header">
                <div className="card-title-row">
                  <h2 className="card-title">
                    
                          <Briefcase
                            size={32}                   
                            strokeWidth={2}             
                            className="service-icon"    
                          />
                    
                     Work Portfolio</h2>
                </div>
              </div>
              <div className="card-content">
                <div className="portfolio-grid">
                  {portfolio.length > 0 ? (
                    portfolio.map((item) => (
                      <Card
                        key={item.portfolioId}
                        className="portfolio-item"
                        onClick={() => setSelectedPortfolioItem(item)}
                      >
                        <div className="portfolio-image">
                          <img
                            src={
                              item.mediaUrl?.length
                                ? item.mediaUrl[0].url
                                : '/placeholder.svg'
                            }
                            alt={item.title}
                          />
                          <Badge variant="primary" className="portfolio-badge">
                            {item.suburb}
                          </Badge>
                        </div>
                        <div className="portfolio-content">
                          <h3 className="portfolio-title">{item.title}</h3>
                          <p className="portfolio-description">{item.description}</p>
                        </div>
                      </Card>
                    ))
                  ) : (
                    <p>No portfolio items found.</p>
                  )}
                </div>
              </div>
            </Card>

            {/* Reviews */}
            <Card>
              <div className="card-header">
                <div className="card-title-row">
                  <h2 className="card-title">
                    
                          <Star
                            size={32}                   
                            strokeWidth={2}             
                            className="service-icon"    
                          />
                    
                    
                     Customer Reviews ({reviews.length})</h2>
                  <Button variant="outline" size="small" onClick={() => setShowAllReviews(true)}>
                    View All Reviews →
                  </Button>
                </div>
              </div>
              <div className="card-content">
                <div className="reviews-list">
                  {reviews.slice(0, 3).map((r) => (
                    <div key={r.reviewId} className="review-item">
                      <div className="review-header">
                        <div className="reviewer-info">
                          <Avatar
                            src={r.userProfileImage}
                            fallback={r.userName
                              .split(' ')
                              .map((n) => n[0])
                              .join('')}
                            size="small"
                          />
                          <span className="reviewer-name">{r.userName}</span>
                        </div>
                        <div className="review-meta">
                          <div className="review-stars">{renderStars(r.overallRating)}</div>
                          <span className="review-date">
                            {new Date(r.dateModified).toLocaleDateString()}
                          </span>
                        </div>
                      </div>
                      <p className="review-comment">{r.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            </Card>
          </div>

          {/* Sidebar */}
          <div className="rightsidebar">
            {/* Contact Info */}
            <Card>
              <div className="card-header">
                <h3 className="card-title">Contact Information</h3>
              </div>
              <div className="card-content">
                <div className="contact-list">
                  <div className="contact-item">
                    <span className="contact-icon">

                          <PhoneCall
                            size={24}                   
                            strokeWidth={2}             
                            className="service-icon"    
                          />

                    </span>
                    <a href={`tel:${businessProfile.phone}`}>{businessProfile.phone}</a>
                  </div>
                  <div className="contact-item">
                    <span className="contact-icon">

                          <Mail
                            size={24}                   
                            strokeWidth={2}             
                            className="service-icon"    
                          />

                    </span>
                    <a href={`mailto:${businessProfile.email}`}>{businessProfile.email}</a>
                  </div>
                  <div className="contact-item">
                    <span className="contact-icon">

                          <Globe
                            size={24}                   
                            strokeWidth={2}             
                            className="service-icon"    
                          />

                    </span>
                    <a href={websiteHref} target="_blank" rel="noopener noreferrer">
                      {rawWebsite.replace(/^https?:\/\//, '')} ↗
                    </a>
                  </div>
                  <div className="contact-item">
                    <span className="contact-icon">

                          <MapPin
                            size={24}                   
                            strokeWidth={2}             
                            className="service-icon"    
                          />

                    </span>
                    <span className="contact-font">{address}</span>
                  </div>
                </div>
              </div>
            </Card>

            {/* Map */}
            <Card>
              <div className="card-header">
                <h3 className="card-title">Location</h3>
              </div>
              <div className="card-content">
                <div className="map-container">

                  <iframe
                    src={mapsembedUrl}
                    width="100%"
                    height="200"
                    style={{ border: 0, borderRadius: '8px' }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Business Location"
                    onError={e => {
                      const staticParams = new URLSearchParams({
                        center: address,
                        zoom: 15,
                        size: '300x200',
                        markers: `color:red|${address}`,
                        key: mapsApiKey
                      }).toString();
                      e.target.src = `https://maps.googleapis.com/maps/api/staticmap?${staticParams}`;
                    }}
                  />

                  <Button className="directions-button" onClick={getDirections}>
                    
                          <MapPin
                            size={32}                   
                            strokeWidth={2}             
                            className="mywhitecolor"    
                          />
                    
                     &nbsp;&nbsp; Get Directions
                  </Button>
                </div>
              </div>
            </Card>

            {/* Stats */}
            <Card>
              <div className="card-header">
                <h3 className="card-title">Business Statistics</h3>
              </div>
              <div className="card-content">
                <div className="stats-grid">
                  <div className="stat-item stat-blue">
                    <div className="stat-icon">

                      <Briefcase
                        size={32}                   // px size
                        strokeWidth={2}             // line thickness
                        className="service-icon"    // use your existing CSS hook
                      />


                    </div>
                    <div className="stat-number">{jobsCompleted}</div>
                    <div className="stat-label">Jobs Complete</div>
                  </div>
                  <div className="stat-item stat-blue">
                    <div className="stat-icon">

                      <Quote
                        size={32}                   // px size
                        strokeWidth={2}             // line thickness
                        className="service-icon"    // use your existing CSS hook
                      />


                    </div>
                    <div className="stat-number">{jobsQuote}</div>
                    <div className="stat-label">Quotes</div>
                  </div>
                  <div className="stat-item stat-blue">
                    <div className="stat-icon">

                      <MessageSquare
                        size={32}                   // px size
                        strokeWidth={2}             // line thickness
                        className="service-icon"    // use your existing CSS hook
                      />

                    </div>
                    <div className="stat-number">{conversationsCount}</div>
                    <div className="stat-label">Messages</div>
                  </div>
                  <div className="stat-item stat-blue">
                    <div className="stat-icon">

                      <Award
                        size={32}                   // px size
                        strokeWidth={2}             // line thickness
                        className="service-icon"    // use your existing CSS hook
                      />


                    </div>
                    <div className="stat-number">
                      {businessProfile.yearsExperience}+ Years
                    </div>
                    <div className="stat-label">Experience</div>
                  </div>
                </div>
              </div>
            </Card>

            {/* Highlights */}
            <Card>
              <div className="card-header">
                <h3 className="card-title">Business Highlights</h3>
              </div>
              <div className="card-content">
                <div className="highlights-list">
                  {businessProfile.fullyInsured && (
                    <div className="highlight-item highlight-green">
                      <span className="highlight-icon">🛡️</span>
                      <span>Fully Insured</span>
                    </div>
                  )}
                  {businessProfile.yearsExperience > 0 && (
                    <div className="highlight-item highlight-blue">
                      <span className="highlight-icon">🏆</span>
                      <span>{businessProfile.yearsExperience}+ Years Experience</span>
                    </div>
                  )}
                  {businessProfile.licenseNumber && (
                    <div className="highlight-item highlight-purple">
                      <span className="highlight-icon">✅</span>
                      <span>Licensed Professional</span>
                    </div>
                  )}
                </div>
              </div>
            </Card>



            {/* Qualifications */}
            <Card>
              <div className="card-header">
                <h3 className="card-title">
                  <Award
                    size={32}                   // px size
                    strokeWidth={2}             // line thickness
                    className="service-icon"    // use your existing CSS hook
                  />
                  
                   Qualifications</h3>
              </div>
              <div className="card-content">
                <div className="qualifications-list">
                  {qualifications.length > 0 ? (
                    qualifications.map((q) => (
                      <div key={q.qualificationId} className="qualification-item">
                        <span className="qual-icon">

                          <CheckCircle
                            size={24}                   // px size
                            strokeWidth={2}             // line thickness
                            className="service-icon"    // use your existing CSS hook
                          />

                        </span>
                        <span>{q.name}</span>
                      </div>
                    ))
                  ) : (
                    <p>No qualifications listed.</p>
                  )}
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>

      {/* All Reviews Modal */}
      {showAllReviews && (
        <Dialog onClose={() => setShowAllReviews(false)}>
          <div className="modal-header">
            <h2>All Customer Reviews</h2>
            <p>
              {reviews.length} reviews with an average rating of{' '}
              {businessProfile.overallRating} stars
            </p>
          </div>
          <ScrollArea className="modal-content">
            <div className="all-reviews-list">
              {reviews.map((r) => (
                <div key={r.reviewId} className="review-item">
                  <div className="review-header">
                    <div className="reviewer-info">
                      <Avatar
                        src={r.userProfileImage}
                        fallback={r.userName
                          .split(' ')
                          .map((n) => n[0])
                          .join('')}
                        size="small"
                      />
                      <span className="reviewer-name">{r.userName}</span>
                    </div>
                    <div className="review-meta">
                      <div className="review-stars">{renderStars(r.overallRating)}</div>
                      <span className="review-date">
                        {new Date(r.dateModified).toLocaleDateString()}
                      </span>
                    </div>
                  </div>
                  <p className="review-comment">{r.description}</p>
                </div>
              ))}
            </div>
          </ScrollArea>
        </Dialog>
      )}

      {/* Portfolio Modal */}
      {selectedPortfolioItem && (
        <Dialog onClose={() => setSelectedPortfolioItem(null)}>
          <div className="modal-header">
            <h2>{selectedPortfolioItem.title}</h2>
            <p>{selectedPortfolioItem.suburb}</p>
          </div>
          <div className="modal-content">
            <img
              src={
                selectedPortfolioItem.mediaUrl?.length
                  ? selectedPortfolioItem.mediaUrl[0].url
                  : '/placeholder.svg'
              }
              alt={selectedPortfolioItem.title}
              className="portfolio-modal-image"
            />
            <p className="portfolio-modal-description">
              {selectedPortfolioItem.description}
            </p>
          </div>
        </Dialog>
      )}
      </div>
    </div>
  )
}

export default BusinessProfileNewV2
